// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
  width: 100%;
  display: flex;
  display: -webkit-box;
  flex-direction: column;
  overflow: auto;
}

.has-support {
  height: 2rem;
  width: 2rem;
}

.status-text-container {
  margin-bottom: 0.6428571429rem;
}

.caret-btn {
  height: 2rem;
  width: 2rem;
  background-size: cover;
  background: #ffffff no-repeat;
}
.caret-btn.caret-up {
  background-image: url("/assets/images/caret-up.svg");
}
.caret-btn.caret-down {
  background-image: url("/assets/images/caret-down.svg");
}

.status-text {
  font-size: 0.7142857143rem;
  font-weight: bold;
  text-transform: uppercase;
}

.status-pill {
  height: 1.5714285714rem;
  padding-left: 0.8571428571rem;
  padding-right: 0.8571428571rem;
  border-radius: 1.5714285714rem;
  font-size: 0.8571428571rem;
  color: #000000;
  display: flex;
  align-items: center;
}
.status-pill.fill {
  color: #ffffff !important;
}

.room-info {
  background: rgba(245, 245, 245, 0.8);
  height: 7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.5714285714rem;
}
.room-info.disabled {
  pointer-events: none;
}
.room-info-small {
  background: #ffffff;
  height: 3.5714285714rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.5714285714rem;
}
.room-info-small .room-date {
  margin-left: 3.1428571429rem;
}

.room-name {
  font-size: 1.4285714286rem;
  font-weight: bold;
}

.room-date {
  color: #a5a498;
  font-weight: bold;
  margin-top: 0.3571428571rem;
}

.pencil-icon {
  padding-right: 2rem;
}
.pencil-icon img {
  height: 1.1428571429rem;
  width: 1.1428571429rem;
}

.item-name {
  height: 3.4285714286rem;
  width: 15.1428571429rem;
  background: #e4e8d9;
  color: #6b645e;
  padding: 1.1428571429rem;
  border-radius: 1.7142857143rem;
  transition: background 0.5s;
}
.item-name.disabled {
  background: rgba(245, 245, 245, 0.8);
}
.item-name.not-available {
  background: #eee3dd;
  color: #974e29;
}

.plus-minus-btn {
  border-radius: 50%;
  display: -webkit-box;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background: #ffffff;
}
.plus-minus-btn img {
  height: 1.1428571429rem;
  width: 1.1428571429rem;
}

.product-list {
  margin-top: 1.2142857143rem;
}
.product-list > div {
  margin-bottom: 1.4285714286rem;
}
.control-btn {
  border-radius: 3.4285714286rem;
  font-size: 0.8571428571rem;
  font-weight: bold;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.control-btn.btn-outline-primary {
  border: 2px solid rgb(255, 205, 0);
}
.control-btn.btn-outline-secondary {
  border: 2px solid rgba(0, 163, 174, 0.2);
}

.cancel-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: 0.7857142857rem;
  margin-right: 0.7857142857rem;
}
.cancel-btn img {
  height: 1.1428571429rem;
  width: 1.1428571429rem;
}

.cancel-text {
  color: #ffcd00;
  font-size: 0.8571428571rem;
  font-weight: bold;
  text-transform: uppercase;
}

.order-status-bubble {
  border: 1px solid #707070;
  border-radius: 50%;
  width: 0.8571428571rem;
  height: 0.8571428571rem;
  margin-right: 1.1428571429rem;
  margin-left: 1.1428571429rem;
}
.order-status-bubble.fill {
  border: none;
}

.ordered {
  border: 2px solid #336699;
}
.ordered.fill {
  background-color: #336699;
}

.delivered {
  border: 2px solid #739c2c;
}
.delivered.fill {
  background-color: #739c2c;
}

.being-made {
  border: 2px solid #dba000;
}
.being-made.fill {
  background-color: #dba000;
}

.close-icon {
  width: 1.1428571429rem;
  height: 1.1428571429rem;
  float: right;
}

.textarea-text {
  background: #f4f5ef;
  border: none;
  height: 5.7142857143rem;
  border-radius: 0.5714285714rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.textarea-text.disabled {
  pointer-events: none;
}

.textarea-icon {
  background: #f4f5ef;
  border: none;
  border-left: none;
  border-radius: 0.5714285714rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.hide-sm {
  opacity: 1;
  transform: translate(0);
  transition: opacity linear 0.3s;
}

.animated {
  transition: top 0.3s;
  top: 100%;
}

.order-btn-container {
  margin-top: 0.7857142857rem;
}

@media screen and (max-height: 450px) {
  .hide-sm {
    opacity: 0 !important;
    transform: translate(9999px) !important;
  }
  .animated {
    position: absolute;
    top: 55px;
    right: 16px;
    left: 16px;
  }
  .animated.second {
    top: 145px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/tray/components/tray-card/tray-card.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;ECkCE,YAAA;EAAA,WAAA;ADjCF;;AAIA;EC6BE,8BAAA;AD7BF;;AAIA;ECyBE,YAAA;EAAA,WAAA;EDrBA,sBAAA;EACA,6BAAA;AAFF;AAIE;EACE,oDAAA;AAFJ;AAKE;EACE,sDAAA;AAHJ;;AAOA;ECSE,0BAAA;EDPA,iBAAA;EACA,yBAAA;AAJF;;AAcA;ECJE,uBAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,0BAAA;EDUA,cAAA;EACA,aAAA;EACA,mBAAA;AAXF;AAaE;EACE,yBAAA;AAXJ;;AAeA;EACE,oCAAA;ECpBA,YAAA;EDsBA,aAAA;EACA,mBAAA;EACA,8BAAA;ECxBA,8BAAA;ADaF;AAcE;EACE,oBAAA;AAZJ;AAoBA;EACE,mBAAA;ECrCA,uBAAA;EDuCA,aAAA;EACA,mBAAA;EACA,8BAAA;ECzCA,8BAAA;ADwBF;AAoBE;EC5CA,4BAAA;AD2BF;;AAsBA;ECjDE,0BAAA;EDmDA,iBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,iBAAA;ECxDA,2BAAA;ADsCF;;AAsBA;EC5DE,mBAAA;AD0CF;AAoBE;EC9DA,uBAAA;EAAA,sBAAA;AD8CF;;AAsBA;ECpEE,uBAAA;EAAA,uBAAA;EDuEA,mBAAA;EACA,cCtGW;EA8BX,wBAAA;EAAA,8BAAA;ED2EA,2BAAA;AAnBF;AAqBE;EACE,oCAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,cAAA;AApBJ;;AAwBA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AArBF;AAuBE;EChGA,uBAAA;EAAA,sBAAA;AD6EF;;AAyBA;ECtGE,2BAAA;ADiFF;AAwBE;ECzGA,8BAAA;ADoFF;AA8BA;EClHE,8BAAA;EAAA,0BAAA;EDqHA,iBAAA;ECrHA,iBAAA;EAAA,oBAAA;AD2FF;AA8BE;EACE,kCAAA;AA5BJ;AA+BE;EACE,wCAAA;AA7BJ;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ECrIA,4BAAA;EAAA,6BAAA;ADyGF;AAgCE;ECzIA,uBAAA;EAAA,sBAAA;AD6GF;;AAkCA;EACE,cC7LQ;EA6CR,0BAAA;EDkJA,iBAAA;EACA,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;EACA,kBAAA;ECxJA,sBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,4BAAA;AD6HF;AAiCE;EACE,YAAA;AA/BJ;;AAmCA;EACE,yBAAA;AAhCF;AAiCE;EACE,yBAAA;AA/BJ;;AAmCA;EACE,yBAAA;AAhCF;AAiCE;EACE,yBAAA;AA/BJ;;AAmCA;EACE,yBAAA;AAhCF;AAiCE;EACE,yBAAA;AA/BJ;;AA+CA;ECpME,sBAAA;EAAA,uBAAA;EDuMA,YAAA;AA5CF;;AA+CA;EACE,mBAAA;EACA,YAAA;EC5MA,uBAAA;EAAA,8BAAA;ED+MA,0BAAA;EACA,6BAAA;AA5CF;AA8CE;EACE,oBAAA;AA5CJ;;AAgDA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EC1NA,8BAAA;ED4NA,yBAAA;EACA,4BAAA;AA7CF;;AAgDA;EACE,UAAA;EACA,uBAAA;EACA,+BAAA;AA7CF;;AAgDA;EACE,oBAAA;EACA,SAAA;AA7CF;;AAgDA;EC3OE,2BAAA;AD+LF;;AAgDA;EACE;IACE,qBAAA;IACA,uCAAA;EA7CF;EAgDA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;EA9CF;EAgDE;IACE,UAAA;EA9CJ;AACF","sourcesContent":["@import 'variables';\n\n:host {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  display: -webkit-box;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.has-support {\n  @include pixelToRem(height, 28px);\n  @include pixelToRem(width, 28px);\n}\n\n.status-text-container {\n  @include pixelToRem(margin-bottom, 9px);\n}\n\n.caret-btn {\n  @include pixelToRem(height, 28px);\n  @include pixelToRem(width, 28px);\n  //@include pixelToRem(margin-bottom, 9px);\n  background-size: cover;\n  background: #ffffff no-repeat;\n\n  &.caret-up {\n    background-image: url('/assets/images/caret-up.svg');\n  }\n\n  &.caret-down {\n    background-image: url('/assets/images/caret-down.svg');\n  }\n}\n\n.status-text {\n  @include pixelToRem(font-size, 10px);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.it-pill {\n  .status-pill {\n    //color: $secondary;\n    //border: 2px solid rgba($secondary, 0.2);\n  }\n}\n\n.status-pill {\n  @include pixelToRem(height, 22px);\n  @include pixelToRem(padding-left, 12px);\n  @include pixelToRem(padding-right, 12px);\n  @include pixelToRem(border-radius, 22px);\n  @include pixelToRem(font-size, 12px);\n  color: #000000;\n  display: flex;\n  align-items: center;\n\n  &.fill {\n    color: #ffffff !important;\n  }\n}\n\n.room-info {\n  background: rgba(245, 245, 245, 0.8);\n  @include pixelToRem(height, 98px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @include pixelToRem(border-radius, $product-border-radius);\n\n  &.disabled {\n    pointer-events: none;\n  }\n\n  &.it-room {\n    //background: #E5F6F7;\n  }\n}\n\n.room-info-small {\n  background: #ffffff;\n  @include pixelToRem(height, 50px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @include pixelToRem(border-radius, $product-border-radius);\n\n  .room-date {\n    @include pixelToRem(margin-left, 44px);\n  }\n}\n\n.room-name {\n  @include pixelToRem(font-size, 20px);\n  font-weight: bold;\n}\n\n.room-date {\n  color: #a5a498;\n  font-weight: bold;\n  @include pixelToRem(margin-top, 5px);\n}\n\n.pencil-icon {\n  @include pixelToRem(padding-right, 28px);\n  img {\n    @include pixelToRem(height, 16px);\n    @include pixelToRem(width, 16px);\n  }\n}\n\n.item-name {\n  @include pixelToRem(height, 48px);\n  @include pixelToRem(width, 212px);\n  background: #e4e8d9;\n  color: $text-color;\n  @include pixelToRem(padding, 16px);\n  @include pixelToRem(border-radius, $support-button-margin);\n  transition: background 0.5s;\n\n  &.disabled {\n    background: rgba(245, 245, 245, 0.8);\n  }\n\n  &.not-available {\n    background: #eee3dd;\n    color: #974e29;\n  }\n}\n\n.plus-minus-btn {\n  border-radius: 50%;\n  display: -webkit-box;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  outline: none;\n  background: #ffffff;\n\n  img {\n    @include pixelToRem(height, 16px);\n    @include pixelToRem(width, 16px);\n  }\n}\n\n.product-list {\n  @include pixelToRem(margin-top, 17px);\n\n  & > div {\n    @include pixelToRem(margin-bottom, 20px);\n  }\n\n  .it_item {\n    //background: #D9E8DB;\n  }\n}\n\n.control-btn {\n  @include pixelToRem(border-radius, $button-border-radius);\n  @include pixelToRem(font-size, 12px);\n  font-weight: bold;\n  @include pixelToRem(padding-top, 14px);\n  @include pixelToRem(padding-bottom, 14px);\n\n  &.btn-outline-primary {\n    border: 2px solid $primary-btn-border;\n  }\n\n  &.btn-outline-secondary {\n    border: 2px solid rgba($secondary, 0.2);\n  }\n}\n\n.cancel-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  @include pixelToRem(margin-left, 11px);\n  @include pixelToRem(margin-right, 11px);\n\n  img {\n    @include pixelToRem(height, 16px);\n    @include pixelToRem(width, 16px);\n  }\n}\n\n.cancel-text {\n  color: $primary;\n  @include pixelToRem(font-size, 12px);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.order-status-bubble {\n  border: 1px solid #707070;\n  border-radius: 50%;\n  @include pixelToRem(width, 12px);\n  @include pixelToRem(height, 12px);\n  @include pixelToRem(margin-right, 16px);\n  @include pixelToRem(margin-left, 16px);\n\n  &.fill {\n    border: none;\n  }\n}\n\n.ordered {\n  border: 2px solid #336699;\n  &.fill {\n    background-color: #336699;\n  }\n}\n\n.delivered {\n  border: 2px solid #739c2c;\n  &.fill {\n    background-color: #739c2c;\n  }\n}\n\n.being-made {\n  border: 2px solid #dba000;\n  &.fill {\n    background-color: #dba000;\n  }\n}\n\n.it {\n  //background-color: rgba(0, 163, 174, 0.1);\n}\n\n.it-name {\n  //color: #00A3AE;\n}\n\n.it-info {\n  //color: #71C3C8;\n}\n\n.close-icon {\n  @include pixelToRem(width, 16px);\n  @include pixelToRem(height, 16px);\n  float: right;\n}\n\n.textarea-text {\n  background: #f4f5ef;\n  border: none;\n  @include pixelToRem(height, 80px);\n  @include pixelToRem(border-radius, 8px);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n\n  &.disabled {\n    pointer-events: none;\n  }\n}\n\n.textarea-icon {\n  background: #f4f5ef;\n  border: none;\n  border-left: none;\n  @include pixelToRem(border-radius, 8px);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.hide-sm {\n  opacity: 1;\n  transform: translate(0);\n  transition: opacity linear 0.3s;\n}\n\n.animated {\n  transition: top 0.3s;\n  top: 100%;\n}\n\n.order-btn-container {\n  @include pixelToRem(margin-top, 11px);\n}\n\n@media screen and (max-height: 450px) {\n  .hide-sm {\n    opacity: 0 !important;\n    transform: translate(9999px) !important;\n  }\n\n  .animated {\n    position: absolute;\n    top: 55px;\n    right: 16px;\n    left: 16px;\n\n    &.second {\n      top: 145px;\n    }\n  }\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
